import moment from "moment";
import NumberFormat from "react-number-format";

// Urutan kolom: field yang diminta ("Status SO" -> statusSebelumnya, CustomerID,
// Nama Customer, "Overdue" -> tglJatuhTempo) ditaruh di depan; sisanya menyusul
// mengikuti urutan semula.
const columnLHIDetail = [
  {
    field: "namaKolektor",
    headerName: "Nama Kolektor",
    width: 200,
    minWidth: 130,
  },
  {
    field: "customerID",
    headerName: "Kode Customer",
    width: 200,
    minWidth: 130,
  },
  {
    field: "customerName",
    headerName: "Nama Customer",
    width: 200,
    minWidth: 130,
  },
  {
    field: "tglJatuhTempo",
    headerName: "Tgl Jatuh Tempo",
    type: "date",
    width: 220,
    minWidth: 130,
    renderCell: (params) =>
      params.value ? <p>{moment(params.value).format("DD-MM-YYYY")}</p> : <></>,
  },
  {
    field: "tglFaktur",
    headerName: "Tanggal Faktur",
    width: 220,
    minWidth: 130,
    type: "date",
    renderCell: (params) =>
      params.value ? <p>{moment(params.value).format("DD-MM-YYYY")}</p> : <></>,
  },
  {
    field: "orderNbr",
    headerName: "No. SO",
    width: 140,
    minWidth: 100,
  },
  {
    field: "balance",
    headerName: "Hutang",
    width: 150,
    minWidth: 120,
    type: "number",
    renderCell: (params) => {
      return (
        <>
          <NumberFormat
            thousandSeparator={true}
            // thousandsGroupStyle="wan"
            value={params.value}
            displayType={"text"}
          />
        </>
      );
    },
  },
  {
    field: "keterangan",
    headerName: "Keterangan",
    width: 180,
    minWidth: 120,
  },
  {
    field: "referenceNbr",
    headerName: "No Invoice",
    width: 150,
    minWidth: 110,
  },
  {
    field: "statusSebelumnya",
    headerName: "Status Sebelumnya",
    width: 220,
    minWidth: 130,
  },
  {
    field: "usrKolektor",
    headerName: "Kolektor ID",
    width: 150,
    minWidth: 110,
  },
  {
    field: "deskCallStatus",
    headerName: "Status Deskcall",
    width: 220,
    minWidth: 130,
  },
  {
    field: "tglKembali",
    headerName: "Tanggal Kembali",
    type: "date",
    width: 220,
    minWidth: 130,
    renderCell: (params) =>
      params.value ? <p>{moment(params.value).format("DD-MM-YYYY")}</p> : <></>,
  },
  {
    field: "ketKembali",
    headerName: "Ket TT",
    width: 150,
    minWidth: 100,
  },
  {
    field: "ttf",
    headerName: "TTF",
    width: 130,
    minWidth: 80,
    renderCell: (params) => <p>{params.value.toString().toUpperCase()}</p>,
  },
  {
    field: "topPrint",
    headerName: "Top Print",
    width: 130,
    minWidth: 100,
  },
  {
    field: "addressLine1",
    headerName: "Alamat",
    width: 260,
    minWidth: 150,
  },
  {
    field: "custHariTT",
    headerName: "Jadwal Tukar TT",
    width: 260,
    minWidth: 150,
  },
  {
    field: "custHariTagih",
    headerName: "Jadwal Tagih",
    width: 260,
    minWidth: 150,
  },
  {
    field: "eFakturNbr",
    headerName: "No. Pajak",
    width: 180,
    minWidth: 130,
  },
];

// DataGrid v4 mengunci maxWidth = width bila maxWidth tidak diberikan,
// sehingga drag-resize tidak bisa melebarkan kolom sama sekali.
// Beri maxWidth besar di semua kolom agar tetap bisa di-resize bebas.
export default columnLHIDetail.map((col) => ({
  maxWidth: 1000,
  ...col,
}));
